import React from "react";
import { inject, observer } from "mobx-react";
import ConfirmationModal from "../../modal-views/confirmation-modal";
import ChangeSingleFieldValueModal from "../../modal-views/change-single-field-value-modal";
import { SearchBar } from "../search/SearchBar";
import { SearchFilters } from "../search/SearchFilters";
import HeaderItem from "./HeaderItem";
import { withRouter } from '../../utils/Utils';
import HttpUtils from "src/utils/HttpUtils";

@inject("userStore", "changeSingleFieldValueModalStore", "searchStore")
@observer
class Header extends React.Component {
  componentDidMount() {
    this.updateStoreWithQueryParams();
  }

  componentDidUpdate(prevProps) {
    const searchParams = this.props.location.search;
    if (searchParams && searchParams !== prevProps.location.search) {
      this.updateStoreWithQueryParams();
    }
  }

  updateStoreWithQueryParams = () => {
    const { location } = this.props;
    const {
      getCubeTypeOptions,
      setSelectedCubeTypes,
      getUserProfiles,
      setSelectedUserProfile,
    } = this.props.searchStore;
    const params = new URLSearchParams(location.search);
    const target = params.get("cubeTypes");
    if (!target) return;
    const selectedCubeTypes = target.split(",");
    let id;
    if (
      selectedCubeTypes.length === 4 &&
      selectedCubeTypes.includes("C") &&
      selectedCubeTypes.includes("D") &&
      selectedCubeTypes.includes("RC") &&
      selectedCubeTypes.includes("NRC")
    ) {
      id = "power";
    } else if (
      selectedCubeTypes.length === 3 &&
      selectedCubeTypes.includes("D") &&
      selectedCubeTypes.includes("RC") &&
      selectedCubeTypes.includes("NRC")
    ) {
      id = "business";
    } else if (selectedCubeTypes.length === 0) {
      id = "full";
    } else {
      id = "custom";
    }
    const profile = getUserProfiles.find((up) => up.id === id);
    if (!profile) return;
    setSelectedUserProfile(profile);
    const cubeTypes = getCubeTypeOptions.filter((cto) =>
      selectedCubeTypes.includes(cto.value)
    );
    setSelectedCubeTypes(cubeTypes.map((option) => option.value));
  };

  render() {
    const { filtersVisible, getFrameworks } = this.props.searchStore;
    const styles = {
      ecbAppHeader: {
        background: "#003299",
        height: "50px",
        width: "100%",
        zIndex: 1,
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
      },
      ecbAppHeaderShowFilters: {
        background: "#003299",
        height: "100px",
        maxHeight: "100px",
        width: "100%",
        zIndex: 1,
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
      },
    };

    return (
      <React.Fragment>
        <div
          style={
            filtersVisible
              ? styles.ecbAppHeaderShowFilters
              : styles.ecbAppHeader
          }
        >
          <div style={{ marginRight: "auto", flex: 1 }}>
            <SearchBar frameworks={getFrameworks} />
          </div>
          
          <HeaderItem name="ADVANCED SEARCH" link="/multisearch" />
          {HttpUtils.isThereAnyPendingRequest ? (
            <div className="pending-requests">
              <div className="nav-loader"></div>
              <div className="pending-requests-tooltip">
                Pending Requests
                <ul style={{ textAlign: "left" }}>
                  {HttpUtils.getPendingRequests.map((request, requestIndex) => (
                    <li key={requestIndex}>{request}</li>
                  ))}
                </ul>
              </div>
            </div>
          ) : null}
          <SearchFilters />
        </div>

        <ChangeSingleFieldValueModal />

        <ConfirmationModal />
      </React.Fragment>
    );
  }
}

export default withRouter(Header);
